import { Component, HostListener, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { nkServices } from '../servicios/app.nkservicios.services';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { HashKeyServices } from '../servicios/app.hashkey.services';
import { AppUtilService } from '../servicios/app.util.service';
import { AtributosService } from '../servicios/atributos.service';
import { ToastNotificationService } from '../servicios/toast-notification.service';
import { FormTestComponent } from '../modal/form-test/form-test.component';
import { FormTestPreguntasComponent } from '../modal/form-test-preguntas/form-test-preguntas.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormmMsgComponent } from '../modal/formm-msg/formm-msg.component';

@Component({
  selector: 'app-pagina',
  templateUrl: './pagina.component.html',
  styleUrls: ['./pagina.component.css']
})
export class PaginaComponent implements OnInit {
 
  fecha:any;
  empresa:any;
  termino:any = '0';
  articulos:any = [];
  banner_1:any;
  banner_2:any;
  banner_3:any;
  banner_4:any;
  banner_5:any;
  banner_6:any;
  banner_7:any;
  banner_8:any;
  banner_9:any;
  banner_10:any;
  txt_titulo_1:any;
  txt_titulo_2:any;
  txt_titulo_3:any;
  txt_titulo_4:any;
  txt_titulo_5:any;
  txt_titulo_6:any;
  txt_titulo_7:any;
  txt_titulo_8:any;
  txt_titulo_9:any;
  txt_titulo_10:any;
  txt_titulo_11:any;
  txt_titulo_12:any;
  txt_titulo_13:any;
  txt_titulo_14:any;
  txt_titulo_15:any;
  txt_subt_1:any;
  txt_subt_2:any;
  txt_subt_3:any;
  txt_subt_4:any;
  txt_subt_5:any;
  txt_subt_6:any;
  txt_subt_7:any;
  txt_subt_8:any;
  txt_1:any;
  txt_2:any;
  txt_3:any;
  txt_4:any;
  txt_5:any;
  txt_6:any;
  txt_7:any;
  txt_8:any;
  txt_9:any;
  txt_10:any;
  txt_11:any;
  txt_12:any;
  txt_13:any;
  txt_14:any;
  txt_15:any;
  txt_16:any;
  txt_17:any;
  txt_18:any;
  txt_19:any;
  txt_20:any;
  cod_empresa:any;
  forma:FormGroup;
  
  constructor(
                private servicio:nkServices,
                private fb:FormBuilder,
                private dialog: MatDialog,
                private router:Router,
                private param:ActivatedRoute,
                private idle: Idle,
                private keepalive: Keepalive,
                private hashkey:HashKeyServices,
                private util:AppUtilService,
                private atrb:AtributosService,
                private notifi:ToastNotificationService,
               ){
                this.forma = fb.group({
                  'des_usuario': ['',[Validators.required]],
                  'tel_usuario': ['',[Validators.required]],
                  'mail_usuario': ['',[Validators.required,Validators.email]],
                  'token': [hashkey.encrypt(atrb.TOKEN)],
                  'cod_empresa': [''],
                  'cod_app': [''],
                  'api':['']
                });
               }

  
  @HostListener('ionScroll',['$event'])
  onWindowScroll($event:any):void{


    let promotionHeader = document.querySelector('.ps-block--promotion-header') as HTMLDivElement
    if(window.screen.width > 480){
      if($event.detail.currentY == 0){
        promotionHeader.style.display = 'block'
      }else{
        promotionHeader.style.display = 'none'
      }
    }else if(window.screen.width < 480 ){
      promotionHeader.style.display = 'none'
    }else{
      promotionHeader.style.display = 'none'
    }
  }

  ngOnInit() {
    this.param.params.subscribe(
      parametro =>{
        this.cod_empresa = parametro['param'];
      }
    );
    /* this.getParametrosApp(); */
    if (this.atrb.COD_VAR.cod_var ? parseInt(this.hashkey.decrypt(this.atrb.COD_VAR.cod_var)) : 0 > 0) {
      this.pruebaBasica();
  }
  }
  async  modalrespuesta(){
    try {
      var accion2 = '';
      var dialogRefp = this.dialog.open(FormmMsgComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {id:'',
              accion:accion2},
        disableClose: true,
        panelClass: 'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRefp.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result !== await this.atrb.CERRAR){
              this.forma.patchValue({
                cod_app : await this.hashkey.encrypt(environment.path_token),
                cod_empresa : await this.atrb.USUARIO_EMPRESA.usuario_empresa,
                api: await this.hashkey.encrypt(await this.atrb.API_REST.gestionWebUsuario)
              });
            this.gestionUsuarios(this.forma.value);
        }else{
          await this.util.cerrarSpinner();
        }
      });
    } catch (error) {
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
  }
  async gestionUsuarios(xvalor:any){
    try {
      console.log(xvalor)
       const response = await  this.servicio.ApiResthttp(xvalor).toPromise();
       this.forma.reset();
        await this.util.cerrarSpinner();
          await this.notifi.success(response.message);
    } catch (error) {
      console.log(error);
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
   }
 async getParametrosApp(){
    try {
      /* await  this.srvc.consultar_sesionhttp(null).toPromise(); */
      let valor = {
        termino: await this.atrb.DEF.toUpperCase(),
        cod_app : await this.hashkey.encrypt(environment.path_token),
        cod_empresa : localStorage.getItem('cod_empresa') ? localStorage.getItem('cod_empresa'): this.cod_empresa,
        api: await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAplicaciones)
      }
      const response = await this.servicio.ApiResthttp(valor).toPromise();
      let img_val;
      for (const i in response) {
        img_val = response[i].constante_app.split('_');
        if (img_val[0].toUpperCase() === await this.atrb.IMG.toUpperCase()) {
          response[i].img = environment.path_storage+response[i].val_def;
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.IMG_BAR_1.toUpperCase()) {
            this.banner_1 = response[i].img;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.IMG_BAR_2.toUpperCase()) {
            this.banner_2 = response[i].img;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.IMG_BAR_3.toUpperCase()) {
            this.banner_3 = response[i].img;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.IMG_BAR_4.toUpperCase()) {
            this.banner_4 = response[i].img;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.IMG_BAR_5.toUpperCase()) {
            this.banner_5 = response[i].img;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.IMG_BAR_6.toUpperCase()) {
            this.banner_6 = response[i].img;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.IMG_BAR_7.toUpperCase()) {
            this.banner_7 = response[i].img;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.IMG_BAR_8.toUpperCase()) {
            this.banner_8 = response[i].img;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.IMG_BAR_9.toUpperCase()) {
            this.banner_9 = response[i].img;
          }
        }
        if (img_val[0].toUpperCase() === await this.atrb.TXT.toUpperCase()) {
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_TITULO_1.toUpperCase()) {
            this.txt_titulo_1 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_TITULO_2.toUpperCase()) {
            this.txt_titulo_2 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_TITULO_3.toUpperCase()) {
            this.txt_titulo_3 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_TITULO_4.toUpperCase()) {
            this.txt_titulo_4 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_TITULO_5.toUpperCase()) {
            this.txt_titulo_5 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_TITULO_6.toUpperCase()) {
            this.txt_titulo_6 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_TITULO_7.toUpperCase()) {
            this.txt_titulo_7 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_TITULO_8.toUpperCase()) {
            this.txt_titulo_8 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_TITULO_9.toUpperCase()) {
            this.txt_titulo_9 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_TITULO_10.toUpperCase()) {
            this.txt_titulo_10 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_TITULO_11.toUpperCase()) {
            this.txt_titulo_11 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_TITULO_12.toUpperCase()) {
            this.txt_titulo_12 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_TITULO_13.toUpperCase()) {
            this.txt_titulo_13 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_TITULO_14.toUpperCase()) {
            this.txt_titulo_14 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_TITULO_15.toUpperCase()) {
            this.txt_titulo_15 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_SUBT_1.toUpperCase()) {
            this.txt_subt_1 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_SUBT_2.toUpperCase()) {
            this.txt_subt_2 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_SUBT_3.toUpperCase()) {
            this.txt_subt_3 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_SUBT_4.toUpperCase()) {
            this.txt_subt_4 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_1.toUpperCase()) {
            this.txt_1 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_2.toUpperCase()) {
            this.txt_2 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_3.toUpperCase()) {
            this.txt_3 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_4.toUpperCase()) {
            this.txt_4 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_5.toUpperCase()) {
            this.txt_5 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_6.toUpperCase()) {
            this.txt_6 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_7.toUpperCase()) {
            this.txt_7 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_8.toUpperCase()) {
            this.txt_8 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_9.toUpperCase()) {
            this.txt_9 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_10.toUpperCase()) {
            this.txt_10 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_11.toUpperCase()) {
            this.txt_11 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_12.toUpperCase()) {
            this.txt_12 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_13.toUpperCase()) {
            this.txt_13 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_14.toUpperCase()) {
            this.txt_14 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_15.toUpperCase()) {
            this.txt_15 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_16.toUpperCase()) {
            this.txt_16 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_17.toUpperCase()) {
            this.txt_17 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_18.toUpperCase()) {
            this.txt_18 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_19.toUpperCase()) {
            this.txt_19 = response[i].val_def;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_20.toUpperCase()) {
            this.txt_20 = response[i].val_def;
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
async pruebaBasica(){
    try {
      let  dialogRef = this.dialog.open(FormTestComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {termino:this.termino},
        disableClose: true,
        panelClass:'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRef.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result.toUpperCase() !== await this.atrb.CERRAR.toUpperCase()){
          await this.util.cerrarSpinner();
          await this.pruebaBasicaPreguntas();
        }else{
          await this.util.cerrarSpinner();
         }
       });
    } catch (error) {
      console.log(error);
        await this.util.cerrarSpinner();
        await this.notifi.customToastNotification(error.error.message);
    }
  }
async pruebaBasicaPreguntas(){
    try {
      let  dialogRef = this.dialog.open(FormTestPreguntasComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {},
        disableClose: true,
        panelClass:'modal_reg',
        backdropClass: "bdrop"
      });
      dialogRef.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result.accion.toUpperCase() !== await this.atrb.CERRAR.toUpperCase()){
              let valor = {
              cod_var: '0',
              cod_usuario: await this.atrb.COD_USUARIO.cod_usuario,
              cod_app : await this.hashkey.encrypt(environment.path_token),
              cod_empresa : await this.atrb.COD_EMPRESA.cod_empresa,
              api: await this.hashkey.encrypt(await this.atrb.API_REST.gestionCodVar)
            }
            const response = await this.servicio.ApiResthttp(valor).toPromise();
            localStorage.setItem('cdv', this.hashkey.encrypt('0'));
            this.termino = '1';
          await this.util.cerrarSpinner();
          this.pruebaBasica();
        }else{
          await this.util.cerrarSpinner();
         }
       });
    } catch (error) {
      console.log(error);
        await this.util.cerrarSpinner();
        await this.notifi.customToastNotification(error.error.message);
    }
  }
async formulario(){
    try {
      let formulario = document.querySelector('#forma') as HTMLElement;
      formulario.scrollIntoView({
        behavior:'smooth',block:'start'
      });
    } catch (error) {
      console.log(error);
    }
  }
async formulario_2(){
    try {
      let formulario = document.querySelector('#forma_2') as HTMLElement;
      formulario.scrollIntoView({
        behavior:'smooth',block:'start'
      });
    } catch (error) {
      console.log(error);
    }
  }
}
